/* eslint-disable */
export default {
  saveLog: 'Enregistrer',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
